import React from 'react';
import PropTypes from 'prop-types';
import FlagCheckeredIcon from 'mdi-react/FlagCheckeredIcon';
import TargetIcon from 'mdi-react/TargetIcon';
import SoccerIcon from 'mdi-react/SoccerIcon';
import TrophyOutlineIcon from 'mdi-react/TrophyOutlineIcon';
import AccountTieIcon from 'mdi-react/AccountTieIcon';
import CreditCardIcon from 'mdi-react/CreditCardIcon';
import FileDocumentOutlineIcon from 'mdi-react/FileDocumentOutlineIcon';
import PodiumIcon from 'mdi-react/PodiumIcon';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import EmailOutlineIcon from 'mdi-react/EmailOutlineIcon';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import ClubheartIcon from '../../../shared/components/custom/ClubheartIcon';
import exampleCurrency from '../../user_tiers/components/exampleCurrency';
import ClubheartFundraiserPreview from './ClubheartFundraiserPreview';

/**
 * Clubheart in two steps: set up a fundraiser, then supporters back it
 * with an amount per goal and pay as goals are scored.
 */
const ClubheartShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  const currency = exampleCurrency(useConfig());
  return (
    <FeatureShowcase
      storageKey="clubheartShowcaseHidden"
      icon={ClubheartIcon}
      title={s('heartInfoTitle')}
      subtitle={s('heartShowcaseSubtitle')}
      showLabel={s('heartShowcaseShow')}
      uses={[
        {
          key: 'setup',
          step: s('showcaseStep', { step: 1 }),
          icon: FlagCheckeredIcon,
          label: s('heartSetupLabel'),
          text: s('heartSetupText'),
          cards: [
            {
              key: 'target',
              icon: TargetIcon,
              title: s('heartCardTarget'),
              text: s('heartCardTargetText', { currency }),
            },
            {
              key: 'amount',
              icon: SoccerIcon,
              title: s('heartCardAmount'),
              text: s('heartCardAmountText'),
            },
            {
              key: 'rewards',
              icon: TrophyOutlineIcon,
              title: s('heartCardRewards'),
              text: s('heartCardRewardsText'),
            },
            {
              key: 'managers',
              icon: AccountTieIcon,
              title: s('heartCardManagers'),
              text: s('heartCardManagersText'),
            },
          ],
        },
        {
          key: 'support',
          step: s('showcaseStep', { step: 2 }),
          icon: ClubheartIcon,
          label: s('heartSupportLabel'),
          text: s('heartSupportText'),
          // The fundraiser as supporters see it, amounts clickable
          interactive: true,
          itemsBeside: true,
          preview: <ClubheartFundraiserPreview />,
          items: [
            { key: 'card', icon: CreditCardIcon, label: s('heartItemCard') },
            {
              key: 'invoice',
              icon: FileDocumentOutlineIcon,
              label: s('heartItemInvoice'),
            },
            {
              key: 'progress',
              icon: ChartLineIcon,
              label: s('heartItemProgress'),
            },
            {
              key: 'leaderboard',
              icon: PodiumIcon,
              label: s('heartItemLeaderboard'),
            },
            {
              key: 'emails',
              icon: EmailOutlineIcon,
              label: s('heartItemEmails'),
            },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

ClubheartShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

ClubheartShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default ClubheartShowcase;
